<template>
  <div class="fillgrid-view" :class="{ 'sidebar-collapsed': leftSidebarCollapsed }">
    <div class="left-sidebar">
      <div class="toggle-button d-flex justify-content-center align-items-center" @click="leftSidebarCollapsed = !leftSidebarCollapsed">
        <i class="fas fa-caret-right" v-if="leftSidebarCollapsed"></i>
        <i class="fas fa-caret-left" v-else></i>
      </div>
      <div class="template-name">
        <i class="fal fa-arrow-circle-left" @click="backToTemplates" title="Cambiar template"></i>
        <span class="text-truncate">Nombre del template</span>
      </div>

      <!-- FILTERS AND VIEWS -->
      <div class="filters">
        <b-tabs justified small>
          <b-tab>
            <template v-slot:title>
              <i class="fad fa-line-columns"></i> Vistas
            </template>

            <FillgridViews :template="templateId" :columns="columns" @apply="applyView"/>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <i class="far fa-search"></i> Búsqueda
            </template>

            <FillgridFilters :template="templateId" :columns="columns" :loading="loadingData" @search="searchData"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <div class="right-side">
      <!-- TOP BUTTONS BAR -->
      <div class="top-tool-bar">
        <div class="action d-none d-lg-block" @click="openAssignUser"><i class="fal fa-user-check"></i> Asignar</div>
        <div class="action d-none d-lg-block" @click="openUpdatesMultiple"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action d-none d-lg-block" @click="openUpdatesMultiple"><i class="fal fa-file-edit"></i> Gestionar</div>
        <div class="action d-none d-lg-block" @click="openDeleteRows" title="Borrar"><i class="fal fa-trash-alt"></i></div>
        <div class="action d-none d-lg-block" @click="downloadData" title="Descargar registros"><i class="fal fa-file-spreadsheet"></i></div>
        <div class="action d-none d-lg-block" @click="openDownloadFiles" title="Descargar achivos"><i class="fal fa-file-download"></i></div>
        <div class="action d-none d-lg-block" :class="{ active: showHistory }" @click="loadRowsWithHistory" title="Mostrar histórico"><i class="fal fa-history"></i></div>
        <div class="action d-none d-lg-block" title="Nuevo"><i class="fal fa-file-plus"></i></div>
        <div class="action d-none d-lg-block" title="Detalle"><i class="fal fa-file-alt"></i></div>
        <div class="action d-none d-lg-block" :class="{ active: showImagesActive }" @click="showImages" title="Mostrar imágenes"><i class="fal fa-camera"></i></div>

        <div class="actions-collapsed d-lg-none">
          <b-dropdown class="shadow-sm" text="Acciones">
            <b-dropdown-item @click="openAssignUser">Asignar</b-dropdown-item>
            <b-dropdown-item @click="openUpdatesMultiple">Modificar</b-dropdown-item>
            <b-dropdown-item @click="openUpdatesMultiple">Gestionar</b-dropdown-item>
            <b-dropdown-item @click="openDeleteRows">Borrar</b-dropdown-item>
            <b-dropdown-item @click="downloadData">Descargar registros</b-dropdown-item>
            <b-dropdown-item @click="openDownloadFiles">Descargar achivos</b-dropdown-item>
            <b-dropdown-item @click="loadRowsWithHistory">Mostrar histórico</b-dropdown-item>
            <b-dropdown-item>Nuevo</b-dropdown-item>
            <b-dropdown-item>Detalle</b-dropdown-item>
          </b-dropdown>
        </div>

        <ul class="pagination shadow-sm">
          <li class="page-item" @click="searchData">
            <a class="page-link" href="#" aria-label="Previous">
              <i class="far fa-angle-double-left"></i>
            </a>
          </li>
          <li class="page-item" @click="searchData"><a class="page-link" href="#">1</a></li>
          <li class="page-item active" @click="searchData"><a class="page-link" href="#">2</a></li>
          <li class="page-item" @click="searchData"><a class="page-link" href="#">3</a></li>
          <li class="page-item" @click="searchData">
            <a class="page-link" href="#" aria-label="Next">
              <i class="far fa-angle-double-right"></i>
            </a>
          </li>
        </ul>
      </div>

      <!-- DATA TABLE -->
      <div class="table-container">
        <table class="data-table table table-hover">
          <thead>
            <tr>
              <template v-for="(item, index) in columns">
                <th :key="index" v-if="isColumnVisible(item.name)" :title="item.name + (item.label.length > 35 ? `\n\n${item.label}` : '')">
                  <div class="cell-selector" style="justify-content: space-between;" v-if="index === 0">
                    <b-form-checkbox size="lg" v-model="toggleAll" @change="toggleAllItemsSelection($event)">{{ item.label }}</b-form-checkbox>
                  </div>

                  <div v-else>
                    <div class="number" v-if="index > 3">{{ index - 3 }}</div>
                    {{ item.label }}
                  </div>

                  <div class="sort" @click="searchData">
                    <i class="fad fa-sort"></i>
                  </div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.ID" :class="{ 'selected': isItemSelected(item.ID) }">
              <template v-for="(value, name, index) in item">
                <template v-if="index === 0">
                  <th :key="index" v-if="isColumnVisible(name)">
                    <div class="cell-selector">
                      <b-form-checkbox size="lg" :checked="isItemSelected(item.ID)" @change="selectItem($event, item)">{{value}}</b-form-checkbox>
                    </div>
                  </th>
                </template>
                <template v-else>
                  <td :key="index" v-if="isColumnVisible(name)">
                    <div v-if="columns[index].type === 'IMAGE'" class="special-field" :class="{ 'image-displayed': showImagesActive && value }">
                      <div v-if="value" @click="showMediaViewer(mediaViewerTypes.IMAGE, value)">
                        <img v-if="showImagesActive" :src="value">
                        <i v-show="!showImagesActive" :id="'show-image-' + item.ID" class="fal fa-camera-alt"></i>
                      </div>

                      <i v-else class="fal fa-camera-alt missing" title="Imagen no proporcionada"></i>

                      <b-popover :target="'show-image-' + item.ID" triggers="hover" placement="right" custom-class="popover-image-preview">
                        <img :src="value">
                      </b-popover>
                    </div>

                    <div v-else-if="columns[index].type === 'MAP'" class="special-field">
                      <i class="fal fa-map-marker-check" title="Ver ubicación" v-if="value" @click="showMediaViewer(mediaViewerTypes.MAP, value)"></i>
                      <i class="fal fa-map-marker-question missing" title="Ubicación no proporcionada" v-else></i>
                    </div>

                    <div v-else :title="value.length > 40 ? value : ''">{{ value }}</div>
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- LOADING MASK -->
      <div class="loading-mask" v-show="loadingData">
        <i class="far fa-spinner-third fa-spin"></i>
      </div>
    </div>

    <!-- ASSIGN MODAL -->
    <b-modal id="assign-user-modal" title="Selecciona un usuario para asignar los registros seleccionados">
      <b-form-select v-model="assignationUser" size="lg" :options="users" class="shadow-sm">
        <template slot="first">
          <option value="" disabled>Usuario</option>
        </template>
      </b-form-select>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="saveAssignationUser" :disabled="!assignationUser">
          Guardar
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal id="delete-rows-modal" title="Borrar registros">
      <h5>Los registros seleccionados serán borrados de forma permanente.</h5>
      <b-form-checkbox size="lg" v-model="activeDeleteRows">Active la casilla para habilitar la opción de borrar</b-form-checkbox>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="danger" @click="deleteRows" :disabled="!activeDeleteRows">
          Borrar registros
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- UPDATES MULTIPLE MODAL -->
    <b-modal content-class="updates-multiple-modal" id="updates-multiple-modal" title="Modificaciones masivas" size="lg" no-close-on-esc no-close-on-backdrop>
      <h5>Agrega los campos que deseas modificar para todos los registros seleccionados</h5>

      <div class="container">
        <div class="fields" v-if="fieldsListToUpdate.length">
          <hr>
          <div class="input-field" v-for="(item, index) in fieldsListToUpdate" :key="index">
            <div class="remove" title="Eliminar campo" @click="deleteFieldToUpdate(index)"><i class="fas fa-times-circle"></i></div>
            <InputFormValue :field="item" :index="index" />
          </div>
        </div>

        <hr style="margin-top: 0">

        <b-form-select v-model="fieldToUpdate" size="lg" class="shadow-sm custom-field-selector" @change="addFieldToUpdate">
          <template slot="first">
            <option value="">+ Campo</option>
          </template>
          <option v-for="(col, index) in columnsFiltered" :key="index" :value="col.name">{{ col.label }}</option>
        </b-form-select>

        <div v-if="fieldsListToUpdate.length">
          <br>
          <b-form-checkbox size="lg" v-model="activeUpdateMultipleRows">Active la casilla para habilitar la opción de actualizar</b-form-checkbox>
        </div>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="applyUpdatesMultiple" :disabled="!fieldsListToUpdate.length || !activeUpdateMultipleRows">
          Aplicar cambios
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- DOWNLOAD FILES MODAL -->
    <b-modal id="download-files-modal" title="Descargar archivos">
      <h5 style="margin-bottom: 15px">Elige los archivos que serán descargados de los registros seleccionados.</h5>
      <b-form-checkbox size="md">Campo 1</b-form-checkbox>
      <b-form-checkbox size="md">Campo 2</b-form-checkbox>
      <b-form-checkbox size="md">Campo 3</b-form-checkbox>
      <b-form-checkbox size="md">Campo 4</b-form-checkbox>
      <b-form-checkbox size="md">Campo 5</b-form-checkbox>

      <hr>

      <b-form-group label="Ingresa un correo electrónico">
        <b-form-input
          v-model.trim="downloadEmail"
          type="email"
          placeholder="Correo electrónico"
        ></b-form-input>
      </b-form-group>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="downloadFiles" :disabled="!downloadEmail">
          Enviar liga de descarga
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import FillgridFilters from '@/components/fillgrid/fillgrid-filters.vue'
import FillgridViews from '@/components/fillgrid/fillgrid-views.vue'
import LocationMap from '@/components/maps/LocationMap.vue'
import InputFormValue from '@/components/forms/input-form-value.vue'
import fillgridData from '@/data/fillgrid'

@Component({
  components: {
    FillgridFilters,
    FillgridViews,
    LocationMap,
    InputFormValue
  }
})
export default class FillgridTest extends Vue {
  templateId: any = 0

  filters: any = {}
  items: any[] = []
  selectedItems: string[] = []
  toggleAll = false
  loadingData = false
  leftSidebarCollapsed = false
  columnsToShow: any[] = []
  showHistory = false
  showImagesActive = false

  // Mock data
  columns: any[] = []

  /** Mock users */
  users = ['bcm6', 'sonm4', 'dgom3', 'tampsm16', 'vmexm6']

  mediaViewerTypes = {
    IMAGE: 1,
    PDF: 2,
    MAP: 3
  }

  mediaViewer = {
    active: false,
    type: 0,
    src: {}
  }

  /** Update operations */
  assignationUser = ''
  activeDeleteRows = false
  activeUpdateMultipleRows = false
  fieldToUpdate = ''
  columnsFiltered: any[] = []
  fieldsListToUpdate: any[] = []
  downloadEmail = ''

  created () {
    this.searchData()

    this.columnsFiltered = this.columns
  }

  backToTemplates () {
    this.$router.push({ name: 'fillgridTemplate' })
  }

  showImages () {
    this.showImagesActive = !this.showImagesActive
  }

  /** Items selection */

  toggleAllItemsSelection (checked: boolean) {
    this.toggleAll = checked
    if (checked) {
      this.selectedItems = this.items.reduce((arr: any[], it: any) => {
        return arr.concat(it.ID)
      }, [])
    } else {
      this.selectedItems = []
    }
  }

  selectItem (checked: boolean, item: any) {
    const index = this.selectedItems.indexOf(item.ID)

    if (checked && index === -1) {
      this.selectedItems.push(item.ID)
    }
    if (!checked && index > -1) {
      this.selectedItems.splice(index, 1)
    }
  }

  isItemSelected (itemId: any) {
    return this.selectedItems.indexOf(itemId) > -1
  }

  /** Fetch data */

  searchData (filters?: any) {
    if (this.loadingData) return
    if (filters) this.filters = filters
    this.loadingData = true
    this.columns = fillgridData.columns
    this.items = fillgridData.data
    setTimeout(() => {
      this.loadingData = false
    }, 1000)
  }

  applyView (selection: any[]) {
    this.columnsToShow = JSON.parse(JSON.stringify(selection))
  }

  isColumnVisible (columnName: string) {
    return !this.columnsToShow.length || columnName === 'ID' || this.columnsToShow.indexOf(columnName) > -1
  }

  /** Media viewer */
  showMediaViewer (type: number, src: any) {
    let route = ''
    switch (type) {
      case this.mediaViewerTypes.MAP:
        route = this.$router.resolve({ name: 'mediapreview', params: { type: 'map' }, query: { lat: src[0], lng: src[1] } }).href
        break
      case this.mediaViewerTypes.IMAGE:
        route = this.$router.resolve({ name: 'mediapreview', params: { type: 'img' }, query: { src: src } }).href
        break
      default:
        this.mediaViewer.src = src
    }
    if (route) {
      window.open(route, '_blank')
    }
  }

  /** Updates */

  openAssignUser () {
    if (this.validateSelection()) {
      this.assignationUser = ''
      this.$bvModal.show('assign-user-modal')
    }
  }

  saveAssignationUser () {
    if (this.assignationUser) {
      // Make the ajax request
      this.items.forEach(it => {
        if (this.selectedItems.indexOf(it.ID) > -1) { it.USER = this.assignationUser }
      })
      this.$bvModal.hide('assign-user-modal')
      this.$bvToast.toast('El usuario ha sido asignado correctamente', {
        title: 'Listo',
        autoHideDelay: 4000
      })
    }
  }

  /** DELETE */

  openDeleteRows () {
    if (this.validateSelection()) {
      this.activeDeleteRows = false
      this.$bvModal.show('delete-rows-modal')
    }
  }

  deleteRows () {
    // Make the ajax request
    this.selectedItems = []
    this.$bvModal.hide('delete-rows-modal')
    this.$bvToast.toast('Los registros han sido borrados correctamente', {
      title: 'Listo',
      autoHideDelay: 4000
    })
    this.searchData()
  }

  /** UPDATES */

  openUpdatesMultiple () {
    if (this.validateSelection()) {
      this.fieldsListToUpdate = []
      this.activeUpdateMultipleRows = false
      this.$bvModal.show('updates-multiple-modal')
    }
  }

  addFieldToUpdate (field: string) {
    const columnConfig = this.columns.find(it => it.name === field)
    this.fieldsListToUpdate.push({ label: columnConfig.label, type: columnConfig.type })
    this.fieldToUpdate = ''
    setTimeout(() => {
      const id = 'input-update-' + (this.fieldsListToUpdate.length - 1)
      const element = document.getElementById(id)
      if (element) element.focus()
    }, 500)
  }

  deleteFieldToUpdate (index: number) {
    this.fieldsListToUpdate.splice(index, 1)
  }

  applyUpdatesMultiple () {
    // Make the ajax request
    if (!this.validFields()) {
      this.$bvToast.toast('Algunos valores ingresados no son correctos', {
        title: 'Validación',
        autoHideDelay: 3500
      })
      return false
    }
    this.$bvModal.hide('updates-multiple-modal')
    this.$bvToast.toast('Los registros han sido actualizados correctamente', {
      title: 'Listo',
      autoHideDelay: 4000
    })
    this.searchData()
  }

  validFields () {
    for (let i = 0; i < this.fieldsListToUpdate.length; i++) {
      if (!this.fieldsListToUpdate[i].valid) {
        return false
      }
    }
    return true
  }

  /** DOWNLOAD FILES & DATA */

  openDownloadFiles () {
    if (this.validateSelection()) {
      this.$bvModal.show('download-files-modal')
    }
  }

  downloadFiles () {
    this.$bvModal.hide('download-files-modal')
    this.$bvToast.toast('La liga para descargar los archivos ha sido enviada al correo proporcionado', {
      title: 'Archivos enviados',
      autoHideDelay: 4000
    })
  }

  downloadData () {
    if (this.validateSelection()) {
      // TODO
    }
  }

  validateSelection (): boolean {
    if (this.selectedItems.length) {
      return true
    } else {
      this.$bvToast.toast('Seleccione al menos un registro', {
        title: 'Acción requerida',
        autoHideDelay: 3200
      })
      return false
    }
  }

  loadRowsWithHistory () {
    this.showHistory = !this.showHistory
    this.searchData()
  }
}
</script>

<style lang="scss">
/* .fillgrid-view {
  $left-sidebar-width: 272px;
  height: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
  transition-delay: 500ms;

  &.sidebar-collapsed {
    .left-sidebar {
      left: $left-sidebar-width * -1;
    }
    .right-side {
      left: 0;
    }
  }

  .left-sidebar {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $left-sidebar-width;
    box-shadow: 0 0 12px #ccc;
    display: flex;
    flex-direction: column;
    z-index: 2;
    background-color: #f8f8f8;
    transition: left 200ms ease;

    .toggle-button {
      position: absolute;
      left: calc(100% + 2px);
      top: 8px;
      width: 22px;
      height: 35px;
      background-color: var(--sidebar-bg-color);
      box-shadow: 1px 1px 3px #bbb;
      cursor: pointer;
    }

    .template-name {
      padding: 14px;
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      border-bottom: 1px solid #e2e2e2;

      i {
        font-size: 1.4rem;
        margin-right: 7px;
        cursor: pointer;
      }
    }

    .filters {
      flex: 1;
      overflow: hidden auto;
      padding: 5px 7px;
      padding: 5px 7px 35px 7px;
      .nav-link {
        color: inherit;
        &.active {
          background-color: #ececec;
          font-weight: bold;
          font-size: 0.9rem;
        }
      }
    }
  }

  .right-side {
    z-index: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: $left-sidebar-width;
    right: 0;
    bottom: 0;
    transition: left 200ms ease;

    .top-tool-bar {
      height: 50px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      padding: 0 10px 0 35px;
      box-shadow: 0 1px 3px #ccc;
      z-index: 2;
      .action {
        padding: 7px 12px;
        border-right: 1px solid #ddd;
        cursor: pointer;
        font-size: 0.9rem;
        font-weight: 300;
        display: flex;
        align-items: center;
        i {
          margin: 0 3px;
          font-size: 1.1rem;
        }
        &:first-child {
          border-left: 1px solid transparent;
        }
        &:hover, &.active {
          background-color: #f0f0f0;
          border-width: 1px 1px 1px 0;
          border-color: #ddd;
          border-style: solid;
          border-radius: 3px;
          &:first-child {
            border-width: 1px 1px 1px 1px;
          }
        }
      }
      .pagination {
        margin: 0;
        margin-left: auto;
        justify-self: flex-end;
        .page-item {
          a {
            border: 0;
            color: inherit;
            background-color: inherit;
          }
          &.active a {
            background-color: var(--secondary);
            color: #fff;
            border-radius: 4px;
          }
        }
      }
    }

    .table-container {
      position: absolute;
      z-index: -1;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      overflow-y: auto;

      .data-table {
        width: auto;
        max-height: 100%;
        font-size: 0.9rem;
        position: relative;
        border-collapse: collapse;

        th {
          background-color: #f5f5f5;
          position: sticky;
        }

        $border-th-color: #ddd;
        thead {
          th {
            top: 0;
            box-shadow: 0 1px 1px $border-th-color;
            padding: 10px 20px 4px 8px !important;
            cursor: pointer;
            z-index: 1;
            &:first-child {
              left: 0;
              z-index: 2;
              box-shadow: 1px 1px 1px $border-th-color;
            }
            .number {
              position: absolute;
              top: -1px;
              right: 0;
              padding: 0 5px;
              height: 14px;
              font-size: 0.6rem;
              font-weight: 400;
              text-align: center;
              background-color: #dfdfdf;
              border-bottom-left-radius: 10px;
            }
            .sort {
              position: absolute;
              top: 0;
              right: 0;
              height: 100%;
              width: 22px;
              text-align: center;
              padding-top: 15px;
              opacity: 0;
            }
            &:hover .sort {
              opacity: 1;
            }
          }
        }

        tbody {
          tr {
            &.selected {
              background-color: #e9e9e9;
            }
            th {
              left: 0;
              box-shadow: 1px 0 1px $border-th-color;
              z-index: 1;
            }
            td {
              position: relative;
              z-index: 0;
            }
          }
        }

        th, td {
          padding: 5px 8px;
          max-width: 350px;
          border: 1px solid #eeeeee;
          vertical-align: middle;
          div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .cell-selector {
          display: flex;
          align-items: center;
          padding-left: 10px;
          div {
            overflow: visible;
          }
          label {
            font-size: 0.9rem;
            padding-top: 5px;
            cursor: pointer;
          }
        }
        .special-field {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          i {
            font-size: 1.2rem;
            color: var(--green);
            &.missing {
              color: var(--red);
            }
          }
          &.image-displayed {
            position: relative;
            width: 150px;
            height: 150px;
            align-items: normal;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }

    .loading-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(#fff, 0.85);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 45px;
    }
  }
}

.popover-image-preview {
  img {
    width: 200px;
  }
}

.updates-multiple-modal {
  h5 {
    text-align: center;
  }
  .container {
    max-width: 400px;
    margin: 0 auto;
  }
  .fields {
    padding: 20px 0;
    .input-field {
      position: relative;
      margin-bottom: 15px;
      padding: 5px;
      border-radius: 4px;
      .remove {
        position: absolute;
        top: 0;
        right: 0;
        padding: 4px;
        cursor: pointer;
        display: none;
        color: var(--danger);
      }
      &:hover {
        background-color: #f0f0f0;
        .remove {
          display: block;
        }
      }
    }
  }
  .custom-field-selector {
    background-color: #e9e9e9;
    cursor: pointer;
    &:hover {
      background-color: #d8d8d8;
    }
  }
} */
</style>
